function getStyle(element, cssRule) {
    let style = element.currentStyle || window.getComputedStyle(element);

    return style[cssRule];
}

module.exports = getStyle;